export default "__VITE_ASSET__pCVWJHvl__"